<template>
  <div style="width：100%">
    <div class="pomotion" v-show="isShow">
      <div class="ojkg">
        <div class="pomotionImg" @click="oopp()">
          <img style="width:100%" src="@/assets/img/pomotion.jpg" alt />
        </div>
        <div class="close">
          <div class="kngdsg" @click="isShow = false">X</div>
        </div>
      </div>
    </div>
    <div class="h5_login">
      <div class="pic_box">
        <img src="@/assets/img/h5_login.png" alt />
      </div>
      <div class="welcome" v-if="!isParnet">{{ $t('other.a394') }}</div>
      <div>
        <van-field class="userAccount" v-model="registerForm.userId" :label="$t('other.a428')" placeholder="邮箱号注册" />
        <!-- <van-field class="userAccount" v-model="registerForm.emailCode" :label="$t('other.a398')"
          :placeholder="$t('other.a432')" /> -->
        <van-field class="userAccount" v-model="registerForm.user.userName" :label="$t('other.a430')"
          :placeholder="$t('other.a430')" />
        <van-field class="userAccount" v-model="registerForm.password" type="password" :label="$t('other.a396')"
          :placeholder="$t('other.a400')" />
        <van-field class="userAccount" v-model="registerForm.secpassword" type="password" :label="$t('other.a397')"
          :placeholder="$t('other.a400')" />
        <van-field class="userAccount" v-model="registerForm.user.userPhone" type="password" :label="$t('other.a521')"
          placeholder="手机号码" />
        <van-field class="userAccount" v-model="registerForm.user.invitationCode" type="password" :label="$t('other.a434')"
          :placeholder="$t('other.a433')" />
      </div>
      <div class="vertifyCode">
        <span @click="sendCode()">{{ $t('other.a402') }}</span>
        <span v-show="countNum !== 120">({{ countNum }}s)</span>
      </div>
      <van-button class="btn" type="info" @click="register()">{{ $t('other.a403') }}</van-button>
      <div class="registore">{{ $t('other.a404') }}</div>
    </div>

    <div class="login">
      <div class="header_box">
        <span class="picBox">
          <img v-if="!isParnet" style="width:100%" src="../assets/img/h5_login.png" />
        </span>
        <span class="inliol">
          <span v-if="!isParnet">{{ $t('other.a406') }}-</span>{{ $t('other.a407') }}
        </span>
      </div>
      <div class="main">
        <div class="typemn">
          <div class="bokjng" v-if="!isParnet">
            <div class="oibvk">{{ $t('other.a406') }}--{{ $t('other.a408') }}：</div>

            <!-- <div class="okhbvkf"><i class="iconfont icon-gou"></i>{{$t('other.a3369')}}</div>
					<div class="okhbvkf"><i class="iconfont icon-gou"></i>{{$t('other.a3370')}}</div> -->
            <div class="okhbvkf"><i class="iconfont icon-gou"></i>{{ $t('other.a409') }}</div>
            <div class="okhbvkf"><i class="iconfont icon-gou"></i>{{ $t('other.a410') }}</div>
            <div class="okhbvkf"><i class="iconfont icon-gou"></i>{{ $t('other.a411') }}</div>
            <!-- <div class="okhbvkf">
              <i class="iconfont icon-gou"></i>{{ $t('other.a409') }}
            </div>
            <div class="okhbvkf">
              <i class="iconfont icon-gou"></i>{{ $t('other.a410') }}
            </div>
            <div class="okhbvkf">
              <i class="iconfont icon-gou"></i>{{ $t('other.a450') }}
            </div> -->
          </div>

          <div class="okmnkdff" v-if="isParnet">
            <div class="oklngds">
              <div class="blockOne">
                <div class="picBox">
                  <img src="../assets/img/illdraw/storenum.png" />
                </div>
                <div class="titledesc">
                  <div>{{ $t('other.a412') }}</div>
                </div>
                <div class="klng">{{ $t('other.a413') }}</div>
              </div>
              <div class="blockOne">
                <div class="picBox">
                  <img src="../assets/img/illdraw/return.png" />
                </div>
                <div class="titledesc">
                  <div>{{ $t('other.a414') }}</div>
                </div>
                <div class="klng">{{ $t('other.a415') }}</div>
              </div>
            </div>

            <div class="oklngds">
              <div class="blockOne">
                <div class="picBox">
                  <img src="../assets/img/illdraw/claim.png" />
                </div>
                <div class="titledesc">
                  <div>{{ $t('other.a416') }}</div>
                </div>
                <div class="klng">{{ $t('other.a417') }}</div>
              </div>
              <div class="blockOne">
                <div class="picBox">
                  <img src="../assets/img/illdraw/chat.png" />
                </div>
                <div class="titledesc">
                  <div>{{ $t('other.a418') }}</div>
                </div>
                <div class="klng">{{ $t('other.a419') }}</div>
              </div>
            </div>
          </div>
          <span class="bcpic">
            <img style="width:100%" src="../assets/img/login_bc1.png" />
          </span>
        </div>
        <div class="bmunlu">
          <div class="ingui">
            <div class="titleDesc" v-if="!isParnet" @click="showPomotion = true">{{ $t('other.a420') }}</div>
            <div class="titleDesc" v-if="isParnet">{{ $t('other.a451') }}</div>
            <div class="bhgkn">
              <div :class="{ 'onkg': true, 'ybvjkf': radio == 1 }" @click="radio = 1">{{ $t('other.a421') }}</div>
              <div :class="{ 'onkg': true, 'pnkn': radio == 2 }" @click="radio = 2">{{ $t('other.a422') }}</div>
            </div>
            <!-- 登录 -->
            <div class="inglknm" v-if="radio == 1 && !isPhoneLogin">
              <el-input ref="inputRef" class="input-text" v-model="inputCount" @keyup.enter.native="getLogin"
                :placeholder="$t('other.a423')">
                <span slot="prefix">{{ $t('other.a425') }}</span>
              </el-input>
              <el-input class="input-text" v-show="!isVisble" type="password" @keyup.enter.native="getLogin"
                v-model="inputPassword" :placeholder="$t('other.a424')">
                <span slot="prefix">{{ $t('other.a426') }}</span>
              </el-input>
            </div>
            <!-- 手机验证码登录 -->
            <div class="inglknm" v-if="radio == 1 && isPhoneLogin">
              <el-select v-if="registorType == 1" v-model="areaCode" placeholder="请选择">
                <span slot="prefix">{{ $t('other.a427') }}</span>
                <el-option v-for="item in distrisAread" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
              <el-input ref="inputRef" class="input-text" v-model="mobileNo" @keyup.enter.native="getLogin"
                :placeholder="$t('other.a423')">
                <span slot="prefix">{{ $t('other.a399') }}：</span>
              </el-input>
              <div style="position:relative">
                <el-input ref="inputRef" class="input-text" v-model="mobileSmscode" :placeholder="$t('other.a432')">
                  <span slot="prefix">{{ $t('other.a401') }}：</span>
                </el-input>
                <el-button class="btn" type="primary" size="mini" @click="sendSmsCode">
                  {{ $t('other.a402') }}
                  <span v-show="countNum !== 120">({{ countNum }})</span>
                </el-button>
              </div>
            </div>



            <!-- 注册 -->
            <div class="inglknm" v-if="radio == 2">
              <div style="text-align:center;margin-bottom:10px;">
                <!-- <span :class="{ 'registorBox': true, 'active': registorType == 1 }" @click="registorType = 1">{{
                  $t('other.a460') }}</span> -->
                <span :class="{ 'registorBox': true, 'active': registorType == 2 }" @click="registorType = 2">{{
                  $t('other.a461') }}</span>
              </div>
              <el-select v-if="registorType == 1" v-model="areaCode" placeholder="请选择">
                <span slot="prefix">{{ $t('other.a427') }}</span>
                <el-option v-for="item in distrisAread" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
              <el-input v-if="registorType == 1" ref="inputRef" class="input-text" v-model="registerForm.userId"
                placeholder="手机号注册">
                <span slot="prefix">{{ $t('other.a428') }}</span>
              </el-input>
              <el-input v-if="registorType == 2" ref="inputRef" class="input-text" v-model="registerForm.userId"
                placeholder="邮箱号注册">
                <span slot="prefix">{{ $t('other.a428') }}</span>
              </el-input>
              <!-- <div style="position:relative">
                <el-input ref="inputRef" class="input-text" v-model="registerForm.emailCode"
                  :placeholder="$t('other.a432')">
                  <span slot="prefix">{{ $t('other.a401') }}：</span>
                </el-input>
                <el-button class="btn" type="primary" size="mini" @click="sendCode()">
                  {{ $t('other.a402') }}
                  <span v-show="countNum !== 120">({{ countNum }})</span>
                </el-button>
              </div> -->
              <el-input ref="inputRef" class="input-text" v-model="registerForm.user.userName"
                :placeholder="$t('other.a430')">
                <span slot="prefix">{{ $t('other.a430') }}：</span>
              </el-input>
              <el-input class="input-text" type="password" v-model="registerForm.password"
                :placeholder="$t('other.a400')">
                <span slot="prefix">{{ $t('other.a400') }}：</span>
              </el-input>
              <el-input class="input-text" type="password" v-model="registerForm.secpassword"
                :placeholder="$t('other.a431')">
                <span slot="prefix">{{ $t('other.a431') }}：</span>
              </el-input>

              <el-input v-if="registorType == 2" ref="inputRef" class="input-text" v-model="registerForm.user.userPhone"
                placeholder="手机号码">
                <span slot="prefix">{{ $t('other.a521') }}：</span>
              </el-input>
              <el-input ref="inputRef" class="input-text" v-model="registerForm.user.invitationCode"
                :placeholder="$t('other.a433')">
                <span slot="prefix">{{ $t('other.a434') }}：</span>
              </el-input>
            </div>

            <div class="ttipk" v-if="radio == 1">
              <div>
                <span class="boxTv" @click="isPhoneLogin = !isPhoneLogin">{{ !isPhoneLogin ? $t('other.a453') :
                  $t('other.a421') }}</span>
                <div class="boxTv" @click="forget">{{ $t('login.forget') }}</div>
              </div>
              <div>
                <el-checkbox v-if="!isPhoneLogin" @change="rementber" v-model="checked">{{ $t('login.remember_password')
                }}</el-checkbox>
              </div>
            </div>


            <div class="oknoig">
              <el-button v-if="radio == 1" class="input-btn" type="primary" @click="getLogin()">{{ $t('login.login')
              }}</el-button>
              <el-button v-if="radio == 2" class="input-btn" type="primary" @click="register()">{{ $t('other.a435')
              }}</el-button>
            </div>
          </div>
          <div style="margin-top:10px;">
            <el-radio v-model="valueRadio" :label="item.value" v-for="item in optionsRadio"
              @change="switchLangq(valueRadio)">{{ item.label }}</el-radio>
          </div>
        </div>
      </div>
      <div class="onkgn1">
        <img style="width:100%" src="../assets/img/demo01.png" />
      </div>
      <div class="onkgn2">
        <img style="width:100%" src="../assets/img/demo02.png" />
      </div>
      <div class="onkgn3">
        <img style="width:100%" src="../assets/img/demo03.png" />
      </div>
      <div class="onkgn4">
        <img style="width:100%" src="../assets/img/demo04.png" />
      </div>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
import { mapState, mapActions, mapMutations } from "vuex";
import newOrders from "@/api/moudles/newOrders";
import api from "../api/moudles/shopaccess";
import utils from "../utils/utils";
import axios from 'axios'
import { Header } from 'element-ui';
export default {
  data() {
    return {
      optionsRadio: [{
        value: 'zh',
        label: 'Chinese'
      }, {
        value: 'en',
        label: 'English'
      }, {
        value: 'vn',
        label: 'Vietnam'
      }, {
        value: 'my',
        label: 'Malaysia'
      }],
      valueRadio: localStorage.getItem('lang') ||'zh',
      radio: 1,
      userData: {},
      emailCode: null,
      showPomotion: false,
      isPhone: false,
      registor_inputCountID: "",
      isShow: false,
      registor_inputusername: "",
      registor_password: "",
      registo_comfirPws: "",
      inputCount: "",
      mobileNo: '',
      mobileSmscode: '',
      value3: false,
      isVisble: false,
      isPhoneLogin: false,
      countNum: 120,
      // 用于倒计时标记，true-正在倒计时
      countFlag: false,
      // 定时器
      intervalBtn: {},
      //默认按钮的值
      btnMsg: this.$t('other.a436'),
      //手机号码
      mobile: "",
      inputPassword: "",
      start_time: "",
      end_time: "",
      options: [
        {
          value: "zh",
          label: "中文"
        },
        {
          value: "en",
          label: "English"
        }
      ],
      value: "",
      checked: false,
      isParnet: false,
      registorType: 2,
      areaCode: "+86",
      islogin: true,
      registerForm: {
        emailCode: null,
        partnerId: null,
        password: null,
        secpassword: null,
        userId: null,
        user: {
          invitationCode: null,
          partnerId: null,
          userId: null,
          userPhone: null,
          userPos: "SELLER",
          userEmail: null
        }
      },
      distrisAread: [
        {
          value: "+86",
          label: "China(+86)"
        },
        {
          value: "+63",
          label: "Philippines(+63)"
        },
        {
          value: "+65",
          label: "Singapore(+65)"
        },
        {
          value: "+84",
          label: "Vietnam(+84)"
        },
        {
          value: "+60",
          label: "Malaysia(+60)"
        },
        {
          value: "+34",
          label: "Spain(+34)"
        },
        {
          value: "+62",
          label: "Indonesia(+62)"
        },
        {
          value: "+66",
          label: "Thailand(+66)"
        },
        {
          value: "+351",
          label: "Portugal(+Portugal)"
        },
        {
          value: "+886",
          label: "Taiwan(+886)"
        }
      ]
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.login.userInfo,
      loginStatus: state => state.login.loginStatus,
      hasLogin: state => state.login.hasLogin
    })
  },
  watch: {
    radio() {
      if (this.radio == 2) {
        let url = location.href;
        if (url.indexOf("?") > -1) {
          this.registerForm.user.invitationCode = this.$route.query.invitationCode;
        }
      } else {
        this.registerForm.user.invitationCode = null;
      }
    }
  },

  created() {
    this.init();
    this.checkPartner();
    var paraString = location.search;
  },
  mounted() {
    this.$refs.inputRef.focus();

  },

  methods: {
    ...mapActions("login", ["getLoginIn", "getLoginByPhoneCode", "getEmailCode", "getRegister"]),
    ...mapActions("order", [
      "getunprocessOrder",
      "auditOrder",
      "getunprocessOrderByshopId"
    ]),
    ...mapMutations("login", ["SWITCH_LANG"]),

    oopp() {
      this.$router.push({
        path: "/promotional",
        query: {
          ...this.userData
        }
      });
    },
    forget() {
      this.$router.push({
        path: '/personal-account',
        query: {
          key: 'resetLoginPws',
          from: 'loginPage',
        }
      })
    },
    sendSmsCode() {
      if (!this.mobileNo) {
        this.$message.warning(this.$t('other.a454'))
        return
      }
      if (this.mobileNo[0] == 0) {
        this.$message.warning(this.$t('other.a479'))
        return
      }

      newOrders
        .getLoginByPhoneCode({
          country: this.areaCode,
          phone: this.mobileNo
        })
        .then(res => {
          if (res.code === 200) {
            if (res.data == "账户余额不足") {
              this.$message.warning(this.$t('other.a455'));
            } else {
              this.$message.success(this.$t('other.a440'));
            }
            this.countDown();
          } else {
            this.$message.warning(res.msg);
            this.countDown();
          }
        });
    },



    checkPartner() {
      let baseurl = location.href;
      let url = "http://" + location.host;
      console.log("url,", url);
      newOrders
        .getPartnerId({
          url: url
        })
        .then(res => {
          if (res.code === 200) {
            let host = location.host;
            console.log("hostdesc", host);
            if (res.data && res.data.partnerId) {
              this.isParnet = true;
              this.registerForm.partnerId = res.data.partnerId;
            } else {
              if (baseurl.indexOf("shopsooo") > -1) {
                this.isParnet = true;
              } else {
                this.isParnet = false;
              }
            }
          } else {
            this.$message.warning(res.msg);
          }
        });
    },

    remberPws() {
      console.log(111);
      const userCount = {
        account: this.inputCount,
        passsword: md5(this.inputPassword + "seller")
      };
      localStorage.setItem("userCount", JSON.stringify(userCount));
    },

    //记住密码
    rementber() {
      if (!this.inputCount || !this.inputPassword) {
        this.$message.error(this.$t('other.a437'));
        return;
      }
      if (this.checked) {
        const userCount = {
          account: this.inputCount,
          passsword: this.inputPassword
        };
        localStorage.setItem("userCount", JSON.stringify(userCount));
      } else {
        localStorage.removeItem("userCount");
      }
    },
    init() {
      let ispc = utils.judgePcOrAndirod();
      console.log("ispc", ispc);

      let account = JSON.parse(localStorage.getItem("userCount"));
      if (account) {
        this.checked = true;
        this.inputCount = account.account;
        this.inputPassword = account.passsword;
      } else {
        this.checked = false;
      }
    },

    getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(";");
      console.log("获取cookie,现在循环");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        console.log(c);
        while (c.charAt(0) == " ") c = c.substring(1);
        if (c.indexOf(name) != -1) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },

    //检查输入的帐号是否是邮箱格式
    vertifyEmail() {
      var email = this.registerForm.userId;
      var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      if (email) {
        if (reg.test(email)) {
          console.log("text", "邮箱格式");
          this.isPhone = false;
        } else {
          console.log("text", "手机号码");
          this.isPhone = true;
        }
      }
    },

    countDown() {
      // 设置btn倒计时时显示的信息
      this.btnMsg = null;
      // 更改btn状态
      this.countFlag = !this.countFlag;
      // 设置倒计时
      this.intervalBtn = setInterval(() => {
        if (this.countNum <= 0) {
          // 重置btn提示信息
          this.btnMsg = this.$t('other.a436');
          // 清除定时器
          clearInterval(this.intervalBtn);
          // 更改btn状态
          this.countFlag = !this.countFlag;
          // 重置倒计时状态
          this.countNum = 121;
        }
        // 倒计时
        this.countNum--;
      }, 1000);
    },

    sendCodeByH5() {
      if (!this.registerForm.userId) {
        this.$toast({
          message: this.$t('other.a438'),
          position: "center"
        });
        this.countDown();
        return;
      }
      newOrders
        .getPhoneCode({
          country: this.areaCode,
          phone: this.registerForm.userId
        })
        .then(res => {
          if (res.code === 200) {
            if (res.data == "账户余额不足") {
              this.$toast({
                message: this.$t('other.a455'),
                position: "center"
              });
            } else {
              this.$toast({
                message: this.$t('other.a440'),
                position: "center"
              });
            }
          } else {
            this.$toast({
              message: res.msg,
              position: "center"
            });
          }
        });
    },

    //检查输入的帐号是否是邮箱格式
    vertifyEmail() {
      var email = this.registerForm.userId;
      var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      if (email) {
        if (reg.test(email)) {
          console.log("text", "邮箱格式");
          this.isPhone = false;
        } else {
          console.log("text", "手机号码");
          this.isPhone = true;
        }
      }
    },

    sendCode() {
      this.vertifyEmail();

      if (this.registorType == 1) {
        if (!this.registerForm.userId) {
          this.$message.warning(this.$t('other.a452'));
          return;
        }

        if (this.registerForm.userId[0] == 0) {
          this.$message.warning(this.$t('other.a479'))
          return
        }
        newOrders
          .getPhoneCode({
            country: this.areaCode,
            phone: this.registerForm.userId
          })
          .then(res => {
            if (res.code === 200) {
              if (res.data == "账户余额不足") {
                this.$message.warning(this.$t('other.a455'));
              } else {
                this.$message.success(this.$t('other.a440'));
              }

              this.countDown();
            } else {
              this.$message.warning(res.msg);
              this.countDown();
            }
          });
      } else {
        if (!this.registerForm.userId) {
          this.$message.warning(this.$t('other.a441'));
          return;
        }

        this.getEmailCode({ email: this.registerForm.userId });
      }
    },

    registerByH5() {
      console.log(this.registerForm);

      if (!this.registerForm.userId) {
        this.$toast({
          message: this.$t('other.a442'),
          position: "center"
        });

        return;
      } else if (!this.registerForm.passsword == null) {
        this.$toast({
          message: this.$t('other.a443'),
          position: "center"
        });
        return;
      } else if (!this.registerForm.emailCode) {
        this.$toast({
          message: this.$t('other.a444'),
          position: "center"
        });
        return;
      }

      if (this.registerForm.password !== this.registerForm.secpassword) {
        this.$toast({
          message: this.$t('other.a445'),
          position: "center"
        });
        return;
      }

      this.registerForm.user.userId = this.registerForm.userId;
      this.registerForm.user.userPhone = this.registerForm.userId;
      this.registerForm.user.userName = this.registerForm.userId;

      let obj = JSON.parse(JSON.stringify(this.registerForm));
      obj.password = md5(obj.password + "seller");
      newOrders.phoneRegister(obj).then(res => {
        if (res.code === 200) {
          this.$toast({
            message: this.$t('other.a446'),
            position: "center"
          });

          this.userData = {
            token: res.data.token,
            userId: res.data.userId
          };

          if (!this.isParnet) {
            this.isShow = true;
          }
        } else {
          this.$toast({
            message: res.msg,
            position: "center"
          });
        }
      });

      console.log(this.registerForm);
      console.log("obj", obj);
    },
    register() {
      this.vertifyEmail();
      if (!this.registerForm.userId) {
        this.$message.warning(this.$t('other.a442'));
        return;
      } else if (!this.registerForm.user.userName) {
        this.$message.warning(this.$t('other.a447'));
        return;
      } else if (!this.registerForm.passsword == null) {
        this.$message.warning(this.$t('other.a443'));
        return;
      }
      //  else if (!this.registerForm.emailCode) {
      //   this.$message.warning(this.$t('other.a444'));
      //   return;
      // }

      if (this.registerForm.password !== this.registerForm.secpassword) {
        this.$message.warning(this.$t('other.a445'));
        return;
      }

      this.registerForm.user.userId = this.registerForm.userId;
      this.registerForm.user.userPhone =
        this.registorType == 1
          ? this.registerForm.userId
          : this.registerForm.user.userPhone;
      this.registerForm.user.userEmail =
        this.registorType == 2 ? this.registerForm.userId : null;

      let obj = JSON.parse(JSON.stringify(this.registerForm));
      let password = this.registerForm.password;
      obj.password = md5(obj.password + "seller");

      if (this.registorType == 1) {
        //手机注册
        newOrders.phoneRegister(obj).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('other.a457'));
            this.userData = {
              token: res.data.token,
              userId: res.data.userId
            };
            setTimeout(() => {
              this.inputCount = this.registerForm.userId;
              this.inputPassword = this.registerForm.password;
              this.getLogin();
            }, 1000);
          } else {
            this.$message.warning(res.msg);
          }
        });
      } else {

        if (!obj.user.invitationCode) {
          this.$confirm(this.$t('other.a3371'), this.$t('other.a142'), {
            confirmButtonText: this.$t('other.a5'), showCancelButton: false,
            type: 'warning'
          }).then(() => {
          })
          return;
        }
        if (!obj.user.userPhone) {
          this.$message.warning(this.$t('other.a458'));
          return;
        }
        this.getRegister(obj).then(res => {
          if (res == "hasSuccess") {
            console.log("111");
            this.inputCount = this.registerForm.userId
            this.inputPassword = password;
            this.getLogin()
          }
        });
      }
    },

    getLogin() {
      if (this.isPhoneLogin) {
        const params = {
          code: this.mobileSmscode,
          userId: this.mobileNo
        }


        this.getLoginByPhoneCode(params).then(res => {
          if (res.code === 200) {
            console.log('desc', res.data)
            if (res.code === 200) {
              console.log(res.data);
              if (this.$route.query.fromh5 == "456852") {
                this.$message.success(this.$t('other.a449'));

                setTimeout(() => {
                  location.replace(
                    "https://" +
                    location.host +
                    "/mh5/distributionStore?invitationCode=" +
                    this.$route.query.invitationCode
                  );
                }, 1000);
              } else if (this.$route.query.Distribution == 0) {
                location.replace("/publicGoods");
              } else {
                this.$message.success(this.$t('other.a449'));

                let host = location.host;
                if (host.indexOf("shopsooo") > -1 || res.data.partnerId) {
                  localStorage.setItem("isShopsooo", true);
                } else {
                  localStorage.setItem("isShopsooo", false);
                }

                setTimeout(() => {
                  if (
                    (res.data.userPos == "SELLER" && res.data.vipLevel == 0) ||
                    res.data.vipLevel == 2
                  ) {
                    location.replace("/index");
                  }
                  if (res.data.vipLevel == 4) {
                    location.replace("/factorysupply/createpurchasing");
                  }
                  if (res.data.userPos == "STORE" && res.data.vipLevel == 0) {
                    location.replace("/storehome");
                  }
                  if (res.data.vipLevel == 1) {
                    location.replace("/stockProduct/single");
                  }
                }, 1000);
              }
            }
          } else {
            this.$message.warning(res.msg)
          }
        })
        return
      }
      let params = {
        userId: this.inputCount.replace(/\s*/g, ""),
        password: md5(this.inputPassword + "seller")
      };

      console.log(params);
      if (!this.inputCount || !this.inputPassword) {
        alert(this.$t('other.a448'));
        return;
      }

      this.getLoginIn(params).then(res => {
        if (res.code === 200) {
          console.log(res.data);
          if (this.$route.query.fromh5 == "456852") {
            this.$message.success(this.$t('other.a449'));

            setTimeout(() => {
              location.replace(
                "https://" +
                location.host +
                "/mh5/distributionStore?invitationCode=" +
                this.$route.query.invitationCode
              );
            }, 1000);
          } else if (this.$route.query.Distribution == 0) {
            location.replace("/publicGoods");
          } else {
            this.$message.success(this.$t('other.a449'));

            let host = location.host;
            if (host.indexOf("shopsooo") > -1 || res.data.partnerId) {
              localStorage.setItem("isShopsooo", true);
            } else {
              localStorage.setItem("isShopsooo", false);
            }

            setTimeout(() => {
              if (
                (res.data.userPos == "SELLER" && res.data.vipLevel == 0) ||
                res.data.vipLevel == 2
              ) {
                location.replace("/index");
              }
              if (res.data.vipLevel == 4) {
                location.replace("/factorysupply/createpurchasing");
              }
              if (res.data.userPos == "STORE" && res.data.vipLevel == 0) {
                location.replace("/storehome");
              }
              if (res.data.vipLevel == 1) {
                location.replace("/stockProduct/single");
              }
            }, 1000);
          }
        }
      });
    },
    gotoregistor() {
      let url = location.href;
      console.log(url);
      if (url.indexOf("dianxiaosheng") > -1) {
        //普通用户
        this.$router.push("/registor");
      } else if (url.indexOf("weanaly") > -1) {
        //印尼用户跳转
        this.$router.push("/registorpage");
      } else if (url.indexOf("shopsbu") > -1) {
        //印尼用户跳转
        this.$router.push("/registor");
      } else {
        this.$router.push("/registor");
      }
    },
    gotoindex() {
      location.replace("/index");
    },
    switchLangq(value) {
      this.SWITCH_LANG(value);
      this.$i18n.locale = value;
    }
  }
};
</script>

<style lang="scss" scoped>
.lineEnter {
  animation: fadeSlideUpIcon 200ms linear 1500ms;
}

.lineLeave {
  animation: fadeSlideUpIcon 200ms linear 0ms;
}

.pomotion {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(68, 66, 66, 0.7);
  z-index: 199;

  .ojkg {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    margin: auto auto;
    display: flex;
    justify-content: center;

    .pomotionImg {
      width: 12rem;
      height: 0;
      padding-bottom: 16rem;
      overflow: hidden;
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      margin: auto auto;
    }

    .close {
      color: #fff;
      position: absolute;

      bottom: 4rem;
      margin: auto auto;
      text-align: center;

      .kngdsg {
        border: 1px solid #fff;
        font-size: 14px;
        border-radius: 51px;
        padding: 6px;
      }
    }
  }
}

@media (max-width: 760px) {
  .login {
    display: none;
  }

  .h5_login {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    .welcome {
      color: #1989fa;
      font-weight: bold;
      padding: 10px 0;
    }

    .vertifyCode {
      width: 100%;
      padding-right: 4rem;
      text-align: right;
      font-size: 14px;
      color: red;
    }

    .userAccount {
      margin: 10px 0;
    }

    .pic_box {
      width: 7rem;
      height: 0;
      padding-bottom: 7rem;
      overflow: hidden;

      img {
        width: 100%;
      }
    }

    .btn {
      width: 10rem;
      margin-top: 2rem;
    }

    .registore {
      font-size: 0.6rem;
      margin-top: 10px;
      color: #1989fa;
    }

    /deep/ .van-field__label {
      width: 3rem;
      margin-right: 0;
    }

    /deep/ .van-field {
      border-bottom: 1px solid #eee;
    }

    /deep/ .van-field::after {
      border-bottom: none;
    }
  }
}

@media (min-width: 1200px) {
  .h5_login {
    display: none;
  }

  .oklngds {
    display: flex;
  }

  .okmnkdff {
    position: relative;
    left: 219px;
    top: 54px;
    z-index: 999;
  }

  .registorBox {
    display: inline-block;
    margin: 0 10px;
    cursor: pointer;
  }

  .active {
    background-color: #66b1ff;
    color: #f2f6fc;
    border-radius: 2px;
    box-sizing: border-box;
    padding: 2px;
  }

  .blockOne {
    width: 310px;
    height: 204px;
    background-color: white;
    border-radius: 8px;
    position: relative;
    margin: 8px;
    box-shadow: #eee 2px 2px 10px;

    .titledesc {
      position: absolute;
      top: 45px;
      right: 0;
      font-size: 22px;
      font-weight: 600;
      width: 220px;
      letter-spacing: 0.91px;
      line-height: 42px;
      text-align: center;
      color: #012257;
      text-align: center;

      .deslk {
        font-size: 14px !important;
        line-height: 16px !important;
        margin-top: 10px !important;
        font-weight: 600;
      }
    }

    .klng {
      padding: 0 20px;
    }

    .picBox {
      width: 130px;
      height: 130px;

      img {
        width: 100%;
      }
    }
  }

  .hideWrapper {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #000;
    opacity: 0.3;
    z-index: 9999;
  }

  .pic_box {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 600px;
    height: 600px;
    overflow: hidden;
    z-index: 999999;
    border-radius: 5px;

    img {
      width: 100%;
    }

    .dolos {
      position: absolute;
      top: 10px;
      right: 10px;
      padding: 5px;
      border-radius: 50px;
      background-color: #f2f6fc;
      border: 1px solid #eee;
      color: #000;
      font-size: 15px;
      cursor: pointer;
    }

    .recharge {
      position: absolute;
      bottom: 50px;
      right: 0;
      left: 0;
      margin: auto auto;
      width: 100%;
      text-align: center;

      .okgn {
        font-size: 20px;
        background-color: #67c23a;
        border-radius: 5px;
        font-weight: bold;
        padding: 20px 25px;
        color: #fff;
        cursor: pointer;
      }
    }
  }

  .login {
    position: absolute;
    width: 100%;
    height: 100vh;
    background-color: #fff;
    background-image: url(../assets/img/login_bg_2e996a1.png);
    background-repeat: no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
    background-position: center 0;
    z-index: 2000;

    .onkgn1 {
      position: absolute;
      top: 80px;
      left: 30%;
      width: 250px;
    }

    /deep/ .el-input__prefix {
      line-height: 40px;
      color: #000;
    }

    .btn {
      position: absolute;
      right: 5px;
      top: 16px;
    }

    .onkgn2 {
      position: absolute;
      bottom: 122px;
      left: 100px;
      width: 304px;
    }

    .onkgn3 {
      position: absolute;
      bottom: 80px;
      right: 0;
      width: 304px;
    }

    .onkgn4 {
      position: absolute;
      bottom: 600px;
      right: 100px;
      width: 304px;
    }

    .oknoig {
      text-align: center;
    }

    .header_box {
      padding: 10px 50px;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .picBox {
        display: inline-block;
        width: 50px;
        height: 50px;
        overflow: hidden;
      }

      .inliol {
        font-size: 20px;
        font-weight: bold;
        padding-left: 20px;
      }
    }

    /deep/ .el-input {
      width: 330px;
    }

    /deep/ .el-input__inner {
      padding-left: 90px;
    }

    .icon-tubiao {
      font-size: 20px;
      line-height: 40px;
    }

    .icon-tubiao::after {
      content: "|";
      padding: 0 10px;
      height: 10px;
    }


    .ttipk {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 20px 0;

      .boxTv {
        cursor: pointer;
        color: #66b1ff;
      }
    }

    .main {
      // display: flex;
      // position: fixed;
      // top: 60px;
      // left: 0;
      // right: 0;
      // bottom: 0;

      .typemn {
        width: 60%;
        position: relative;
        display: flex;

        .bcpic {
          width: 558px;
          overflow: hidden;
          position: fixed;
          bottom: 120px;
          left: 25%;
        }

        .bokjng {
          position: absolute;
          top: 123px;
          left: 100px;
          z-index: 99;
        }

        .oibvk {
          font-size: 32px;
          font-weight: bold;
          color: #66b1ff;
          margin-bottom: 35px;
        }

        .okhbvkf {
          margin-bottom: 40px;
          font-size: 23px;
        }

        .icon-gou {
          color: rgb(1, 191, 126);
          margin-right: 10px;
        }
      }

      .bmunlu {
        margin-top: 65px;
				z-index: 999;

        .ingui {
          width: 330px;
          box-shadow: 0px 0px 20px 0px rgba(153, 169, 191, 20%);
          padding: 0 15px;
          border-radius: 5px;

          .titleDesc {
            font-size: 25px;
            text-align: center;
            padding: 40px 0 20px 0;
            color: #66b1ff;
          }

          .bhgkn {
            display: flex;
            width: 100%;
            justify-content: space-between;
            margin: 10px 0 20px 0;
            position: relative;

            .onkg {
              width: 50%;
              text-align: center;
              padding-bottom: 8px;
              color: #99a9bf;
              cursor: pointer;
            }

            .ybvjkf {
              color: #000;
            }

            .ybvjkf::after {
              content: "";
              width: 50%;
              height: 0.5px;
              background-color: #66b1ff;
              position: absolute;
              bottom: 0;
              left: 0;
            }

            .pnkn {
              color: #000;
            }

            .pnkn::after {
              content: "";
              width: 50%;
              height: 0.5px;
              background-color: #66b1ff;
              position: absolute;
              bottom: 0;
              right: 0;
            }
          }

          .inglknm {
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
        }
      }
    }
  }

  .login-title {
    font-size: 20px;
    font-weight: bold;
  }

  .input-text {
    width: 300px;
    margin: 10px 0;
  }

  .login-left,
  .login-right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .registor {
    width: 80%;
    text-align: right;
    cursor: pointer;
  }

  .login-header {
    position: absolute;
    top: 10px;
    right: -140px;
  }

  .input-btn {
    width: 200px;
    border-radius: 30px;
    margin-top: 20px;
    margin-bottom: 50px;
  }
}
</style>
